module.exports = __webpack_public_path__ + "images/emoji/rage4.83f50c71c8ab9c57f6e3.png";